import React, { useState, useRef } from 'react'

export default function PlayerRow(props) {
  const pr = props.pr
  const [editCost, setEditCost] = useState(false)
  const costInputRef = useRef(null)
  const cost_of_player = parseFloat(pr.cost_of_player)
  const isFullyPaid = pr.paid

  const changeCost = () => {
    const cost = costInputRef.current.value
    if (cost < 0 || cost > 1000000) return

    if (cost_of_player != cost) props.onEditCost({ id: pr.id, cost: cost })
    setEditCost(false)
  }

  return <tr>
    <td className='col-xs-4 text-left player-name'>
      <div className='row'>
        <div className='col-sm-7'><h5>{pr.name}</h5></div>
        <div className='col-sm-3 text-center'>
          { pr.auto_pay && <span className='label label-primary'>Auto Pay</span> }
          { pr.iphone && <span className='label label-primary'>iPhone User</span> }
        </div>
      </div>
    </td>

    <td className='col-xs-2'>
      { pr.pleisystem && !editCost &&
        <h5>
          <span className='cost'>$&nbsp;{cost_of_player.toFixed(2)}</span>&nbsp;
          {!isFullyPaid && <span className='toggle-cost-edit fa fa-pencil' onClick={() => setEditCost(true)}></span>}
        </h5>
      }
      { pr.pleisystem && editCost &&
        <form>
          <div className='dollar-field inline'>
            <input step='0.01' className='form-control' type='number' 
              autoFocus ref={costInputRef} onBlur={() => setTimeout(() => { setEditCost(false) }, 300)}/>
          </div>
          <input type='submit' name='commit' value='OK' className='btn btn-info' 
            onClick={(e) => { e.preventDefault(); changeCost() }} />
        </form>
      }
    </td>

    <td className='col-xs-1 actions'>
      { pr.pleisystem && isFullyPaid && <button className='btn btn-success' type='button'>Paid</button> }
      { pr.pleisystem && !isFullyPaid && 
        <a className='btn btn-info clickable' onClick={() => props.onPayment(pr.id)}>Pay</a> 
      }
    </td>
  </tr>
}
